module.exports = __webpack_public_path__ + "static/img/video_icon04.931fd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video_icon04.png
// module id = rnsp
// module chunks = 1